import { useMemo } from 'react'
import { z } from 'zod'

import i18n from '@/lib/i18n'

import { Language } from '../../i18n'

const schema = z.enum(['ja', 'en'])

export const useLanguage = () => {
  const language = useMemo((): Language => {
    try {
      return schema.parse(i18n.language)
    } catch {
      return 'ja'
    }
  }, [])

  const changeLanguage = async (language: Language) => {
    await i18n.changeLanguage(language)
    window.location.reload()
  }

  return { language, changeLanguage }
}
